var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n      © 2019 GEAT. All Rights Reserved.\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }